import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { CombineMultipleUtilitiesModalForm } from './form';
import { SimpleModal, Icon } from '@livable/saas-react-components';
export const CombineMultipleUtilitiesModal = observer(_ref => {
  _objectDestructuringEmpty(_ref);
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    title: t('add_new_property_flow.combine_multiple_utilities'),
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      'custom-attribute': '206-CombineMultipleUtilitiesModal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('add_new_property_flow.combine_multiple_utilities')))
  }, /*#__PURE__*/React.createElement(CombineMultipleUtilitiesModalForm, null));
});